import  { useState } from 'react'

import { useMutation } from 'react-query'
import { postCountry } from '../../../../MyApi/sb/countries'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

import AddCountry from '../../../../Components/sb/countries/countriesStore/AddCountry'
import PageHeader from '../../../../Components/UI/PageHeader'


const CountriesStore = () => {
const [countryName ,setCountryName]= useState("")
const [currencyId ,setCurrencyId]= useState("")
const [selectedCurrency ,setSelectedCurrency] =useState("")
const [currencyCode ,setCurrencyCode]= useState("")
const [phoneCode ,setPhoneCode]= useState("")
const { i18n}=useTranslation()
const lang =i18n.language
 const mutation = useMutation(["postCountries",lang] , (postData)=>postCountry(postData ,lang) ,{
   onSuccess:(data)=>{
    
        toast.success(`${data.message}`)
        setCountryName("")
        setCurrencyId("")
        setCurrencyCode("")
        setPhoneCode("")
        setSelectedCurrency("")
    },
    onError:(error)=>{
       toast.error(`${error.response.data.message}`)
    }
 })

 const handlePostRequest =()=>{
    mutation.mutate({
        name:countryName,
        phone_code:phoneCode,
        sb_currency_id:currencyId,
        code:currencyCode
    })
 }
 const isDisabled= ()=>{
    return !(countryName  && currencyId && currencyCode && phoneCode)  
 }
  return ( 

    <div>
        <PageHeader title="Add country" showBack={true} saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <AddCountry  setSelectedCurrency={setSelectedCurrency} selectedCurrency={selectedCurrency}     setCountryName={setCountryName} setCurrencyId={setCurrencyId} setCurrencyCode={setCurrencyCode} setPhoneCode={setPhoneCode}  countryName={countryName} currencyId={currencyId} currencyCode={currencyCode}  phoneCode={phoneCode}/>
    </div>
  )
}

export default CountriesStore